import $ from "jquery";
import { renderBootstrapErrors } from "./util/render_bootstrap_errors";
import { ajaxFormErrors } from "./util/ajax_form_errors.mjs";
import toastr from "toastr";

const formSuccess = function (e, data) {
  $("#requestDemoModal").modal("hide");
  // space doesn't work with jQuery params
  // a1: telephone number
  // a2: company
  // a3: country
  var fullName = [data["first_name"], data["last_name"]].join("%20");
  var params = {
    email: data["email"],
    a1: data["company"],
    a2: data["telephone"],
    a3: data["country"]
  };
  window.Calendly.initPopupWidget({
    url: "https://calendly.com/gwisales?full_name=" + fullName + "&" + $.param( params )
  });
};

const formError = function (e, xhr) {
  const errors = ajaxFormErrors(xhr);
  if (!errors) {
    toastr.error("Something went wrong. Please try again.");
    return;
  }

  const recaptchaError = (errors.base || []).filter((msg) => (msg.match(/recaptcha/i)));
  if (recaptchaError.length > 0) {
    toastr.error("Please complete reCAPTCHA.");
  } else {
    toastr.error("Please fix form errors.");
  }
  renderBootstrapErrors($(this), errors);
};

$(document).on("turbolinks:load", function () {
  $("#new_free_demo_request")
    .on("ajax:success", formSuccess)
    .on("ajax:error", formError);
});
